export default __webpack_public_path__ + "static/media/item2@2x.7839d5ba.png";